import type { MediaAudio as GeneratedMediaAudioProps } from "@homeinstead/schemas";

import {
  MediaAudioPlayer,
  MediaFigure,
} from "@homeinstead/ui/components/Media";
import { SanityImage } from "~www/components/SanityImage";
import { getSanityFileUrl } from "~www/lib/sanity/get-sanity-file-url";

type MediaAudioProps = Omit<GeneratedMediaAudioProps, "_type"> & {
  className?: string;
};

/**
 * Editorial audio. The external-URL source passes straight through, which is
 * what lets podcast episodes hosted on a third-party CDN play without being
 * re-uploaded into Sanity.
 */
function MediaAudio({
  allowDownload,
  audioFile,
  audioUrl,
  className,
  coverArt,
  durationSeconds,
  sourceType,
  title,
}: MediaAudioProps) {
  const src = sourceType === "file" ? getSanityFileUrl(audioFile) : audioUrl;

  if (!src) {
    return null;
  }

  return (
    <MediaFigure className={className}>
      <div className="flex items-center gap-4">
        {coverArt?.image?.asset?._ref ? (
          <SanityImage
            alt={coverArt.image.alt ?? ""}
            asset={coverArt.image}
            className="size-20 shrink-0 rounded-lg object-cover"
            height={80}
            width={80}
          />
        ) : null}

        <div className="min-w-0 flex-1">
          <p className="font-jakarta font-semibold text-base">{title}</p>
          <MediaAudioPlayer
            allowDownload={allowDownload}
            durationSeconds={durationSeconds}
            src={src}
            title={title}
          />
        </div>
      </div>
    </MediaFigure>
  );
}

export { MediaAudio };
